import styled, { css } from 'styled-components';

import { getFontStyle } from '../../utils';
import { rem } from '../../utils/index';

export type ToggleSize = 'Small' | 'Medium';

export type ToggleIconPosition = 'start' | 'end';

export const StyledIcon = styled.span`
  display: inline-flex;
`;

export type ToggleShape = 'default' | 'circular';

export const StyledToggle = styled.button<{
  active: boolean;
  disabled: boolean;
  iconPosition: ToggleIconPosition;
  shape: ToggleShape;
  size: ToggleSize;
  title?: string;
}>`
  white-space: nowrap;
  box-sizing: border-box;
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  flex: 1;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  outline: none;
  ${getFontStyle('Body')}

  user-select: none;
  ${({ theme, shape, iconPosition, active, title }) => css`
    border-radius: ${shape === 'circular' ? '50%' : rem(theme.Border.Radius.Medium)};
    flex-direction: ${iconPosition === 'start' ? 'row' : 'row-reverse'};
    gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
    transition: all ${({ theme }) => theme.Transition.Timing.Out};
    color: ${active ? theme.Color.Brand.Dark : theme.Color.Neutrals.Dark};
    background: ${active ? theme.Color.Neutrals.Border : 'transparent'};
    min-width: ${!title ? rem(theme.Components.PopupMenu.Button.Size) : 'auto'};
    ${StyledIcon} {
      fill: ${active ? theme.Color.Brand.Dark : theme.Color.Neutrals.Dark};
    }
  `}
  &:hover {
    ${({ theme }) => css`
      background: ${theme.Components.Panel.BackgroundHover};
      transition: all ${theme.Transition.Timing.In};
    `}
  }
  &[disabled],
  &.disabled {
    color: ${({ theme }) => theme.Color.Neutrals.Text};
    ${StyledIcon} {
      fill: ${({ theme }) => theme.Color.Neutrals.Gray};
    }
  }
  ${({ size, theme }) => {
    switch (size) {
      case 'Small':
        return css`
          height: ${rem(theme.Components.PopupMenu.Button.Size)};
          padding: ${({ theme }) =>
            rem(theme.Spacing.Size.XXSmall + 2)}; // +2px to compensate for the border
        `;
      case 'Medium':
      default:
        return css`
          min-height: ${({ theme }) => rem(theme.Spacing.Size.Large)};
          padding: ${({ theme }) =>
            `${rem(theme.Spacing.Size.XSmall)} ${rem(theme.Spacing.Size.Small)}`};
        `;
    }
  }}
`;
